import axios from "axios";

export const changeRole = async (roleId, token) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_IAM}/role/change`,
      {
        RoleId: roleId
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    console.log("Permissions Data:", response.data);
    return response.data;
  } catch (error) {
    const tokenExpiredError =
      error?.response?.data?.error?.message === "jwt expired"
        ? "Token Expired"
        : "failed to switch role";
    throw tokenExpiredError;
  }
};

export const getModuleList = async ({ ProductId }) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      `${process.env.REACT_APP_IAM}/mapping/productbasedmodules`,
      {
        ProductId: ProductId
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    console.log("Module Data:", response.data);
    return response.data;
  } catch (error) {
    const tokenExpiredError =
      error?.response?.data?.error?.message === "jwt expired"
        ? "Token Expired"
        : "failed to switch role";
    throw tokenExpiredError;
  }
};

export const getScreenList = async (ModuleId) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      `${process.env.REACT_APP_IAM}/mapping/modulescreen/list`,
      {
        ModuleId: ModuleId
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    console.log("Screen Data:", response.data);
    return response.data;
  } catch (error) {
    const tokenExpiredError =
      error?.response?.data?.error?.message === "jwt expired"
        ? "Token Expired"
        : "failed to switch role";
    throw tokenExpiredError;
  }
};